module.exports = __webpack_public_path__ + "img/three3Red.88ef9584.jpg";